import { createRoot } from 'react-dom/client';
import slide1 from '../images/login-page-slide-1.png';
import slide2 from '../images/login-page-slide-2.png';
import slide3 from '../images/login-page-slide-3.png';
import slide4 from '../images/login-page-slide-4.png';
import Slider from './components/slider/Slider';
import { getSeasonalLoginSlideDecision } from './components/seasonal/seasonalLoginSlides';

interface SlideButton {
    text: string;
    link: string;
}

interface SlideConfig {
    src: string;
    title: string;
    description: string;
    button?: SlideButton;
}

export const slides: SlideConfig[] = [
    {
        src: slide1,
        title: gettext('LOGIN_PAGE_SLIDE_REPORT_BUILDER_TITLE'),
        description: gettext('LOGIN_PAGE_SLIDE_REPORT_BUILDER_DESCRIPTION'),
        button: {
            text: gettext('LOGIN_PAGE_SLIDE_REPORT_BUILDER_BUTTON_TEXT'),
            link: 'https://www.youtube.com/watch?v=vJUtF5Yl_2M',
        },
    },
    {
        src: slide2,
        title: gettext('LOGIN_PAGE_SLIDE_1_TITLE'),
        description: gettext('LOGIN_PAGE_SLIDE_1_DESCRIPTION'),
        button: {
            text: gettext('LOGIN_PAGE_SLIDE_1_BUTTON_TEXT'),
            link: 'https://www.omnidots.com/en/swarm-sound-level-meter',
        },
    },
    {
        src: slide3,
        title: gettext('LOGIN_PAGE_SLIDE_2_TITLE'),
        description: gettext('LOGIN_PAGE_SLIDE_2_DESCRIPTION'),
    },
    {
        src: slide4,
        title: gettext('LOGIN_PAGE_SLIDE_3_TITLE'),
        description: gettext('LOGIN_PAGE_SLIDE_3_DESCRIPTION'),
    },
];

interface LoginPageSliderModuleArgs {
    options: {
        elementId: string;
    };
}

function loginPageSliderModule({ options: { elementId } }: LoginPageSliderModuleArgs): void {
    const container = document.getElementById(elementId);
    if (!container) {
        return;
    }

    const seasonalSlide = getSeasonalLoginSlideDecision();
    const allSlides = seasonalSlide ? [seasonalSlide, ...slides] : slides;

    createRoot(container).render(<Slider slides={allSlides} />);
}

export default loginPageSliderModule;
